<div class="ccp-root">

  <!-- Fondo aurora -->
  <div class="ccp-aurora ccp-aurora-a"></div>
  <div class="ccp-aurora ccp-aurora-b"></div>
  <div class="ccp-aurora ccp-aurora-c"></div>
  <div class="ccp-grain"></div>

  <!-- Loading overlay -->
  <div *ngIf="(loginFacade.responseLoading$ | async)?.loading" class="ccp-loading">
    <div class="ccp-spin-wrap">
      <div class="ccp-comet"></div>
      <p class="ccp-spin-lbl">Actualizando contraseña...</p>
    </div>
  </div>

  <div class="ccp-card">

    <div class="ccp-accent-bar"></div>

    <!-- Encabezado: badge flotante sobre fondo blanco -->
    <div class="ccp-header">
      <div class="ccp-icon-badge">
        <mat-icon>lock_reset</mat-icon>
      </div>

      <span class="ccp-chip">
        <span class="ccp-chip-dot"></span>
        Seguridad de la cuenta
      </span>

      <h1 class="ccp-title">Debes cambiar tu contraseña</h1>
      <p class="ccp-sub">Es tu primer inicio de sesión, por seguridad actualiza tu contraseña para continuar.</p>
    </div>

    <!-- Cuerpo -->
    <div class="ccp-body">

      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" class="ccp-form">

        <mat-form-field appearance="outline" class="ccp-field">
          <mat-label>Contraseña anterior</mat-label>
          <input matInput [type]="hide1 ? 'password' : 'text'"
            formControlName="anteriorPassword" required autocomplete="off">
          <mat-icon matPrefix class="ccp-field-icon">lock_outline</mat-icon>
          <button type="button" mat-icon-button matSuffix (click)="hide1 = !hide1"
            [attr.aria-label]="'Mostrar contraseña'" [attr.aria-pressed]="hide1">
            <mat-icon>{{ hide1 ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" class="ccp-field">
          <mat-label>Contraseña nueva</mat-label>
          <input matInput [type]="hide2 ? 'password' : 'text'"
            formControlName="newPassword" required autocomplete="off">
          <mat-icon matPrefix class="ccp-field-icon">vpn_key</mat-icon>
          <button type="button" mat-icon-button matSuffix (click)="hide2 = !hide2"
            [attr.aria-label]="'Mostrar contraseña'" [attr.aria-pressed]="hide2">
            <mat-icon>{{ hide2 ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-hint>Mínimo 8 caracteres</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="ccp-field">
          <mat-label>Repetir contraseña nueva</mat-label>
          <input matInput [type]="hide3 ? 'password' : 'text'"
            formControlName="repeatPassword" required autocomplete="off">
          <mat-icon matPrefix class="ccp-field-icon">vpn_key</mat-icon>
          <button type="button" mat-icon-button matSuffix (click)="hide3 = !hide3"
            [attr.aria-label]="'Mostrar contraseña'" [attr.aria-pressed]="hide3">
            <mat-icon>{{ hide3 ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <div *ngIf="passwordsDoNotMatch" class="ccp-error">
          <mat-icon>error_outline</mat-icon>
          Las contraseñas no coinciden.
        </div>

        <div class="ccp-actions">
          <button mat-button type="button" class="ccp-btn-back" (click)="cerrarSesion()">
            <mat-icon>arrow_back_ios</mat-icon> Salir
          </button>
          <button mat-raised-button type="submit" class="ccp-btn-submit"
            [disabled]="(loginFacade.responseLoading$ | async)?.loading">
            <ng-container *ngIf="!(loginFacade.responseLoading$ | async)?.loading; else ccpLoadTpl">
              Cambiar contraseña &nbsp;<mat-icon>east</mat-icon>
            </ng-container>
            <ng-template #ccpLoadTpl>
              <mat-spinner diameter="22" strokeWidth="3"></mat-spinner>
            </ng-template>
          </button>
        </div>

      </form>

    </div>

  </div>

</div>
